import { FC } from 'react';
import PresentationModal from '../../organisms/PresentationModal';
import SpanList, { ErrorItemType } from '../../atoms/SpanList';

interface DocumentListModalProps {
    id: string;
    show: boolean;
    title: string;
    items: string[];
    onClose: () => void;
    itemType?: ErrorItemType;
}

const DocumentListModal: FC<DocumentListModalProps> = ({
    id,
    show,
    title,
    items,
    onClose,
    itemType = ErrorItemType.SUCCESS,
}) => {

    return (
        <PresentationModal
            id={id}
            show={show}
            onClose={onClose}
            header={title}
            height="500px"
        >
            <div className="p-4 space-y-4">
                {itemType === ErrorItemType.SUCCESS ?
                    <SpanList
                        itemType={itemType}
                        items={items.map((it) => ({ label: it }))}
                    /> :
                    <SpanList
                        itemType={itemType}
                        items={items.map((it) => ({ label: it }))}
                    />
                }
            </div>
        </PresentationModal>
    );
};

export default DocumentListModal;
